import { render, staticRenderFns } from "./CsimSchemaPeriod.vue?vue&type=template&id=6fd10bd6&scoped=true"
import script from "./CsimSchemaPeriod.vue?vue&type=script&lang=js"
export * from "./CsimSchemaPeriod.vue?vue&type=script&lang=js"
import style0 from "./CsimSchemaPeriod.vue?vue&type=style&index=0&id=6fd10bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd10bd6",
  null
  
)

export default component.exports